var select_variant_id = $('#mvu-addToCart-btn').data('selected-variant');
$('#mvu-makeselection').on('click', function(e){
  e.preventDefault();
  $(this).addClass('hide-btn');
  $('.mvu-content-lower').addClass('show-mvu-options');
});
$(document).ready(function(){
  if ($(window).width() < 800) { 
    if(!$('.mv-upsell').hasClass('mobile-view')){
      $('.mv-upsell').addClass('mobile-view')
    }
  }
});

$(window).on('resize', function(){
  if ($(window).width() < 800) { 
    if(!$('.mv-upsell').hasClass('mobile-view')){
      $('.mv-upsell').addClass('mobile-view')
    }
  }else{
    $('.mv-upsell').removeClass('mobile-view')
  }
});


$('#mvu-options select').on('change', function() {
  var this_parent = $(this).parent();
  let select_title = '';
  for(let i = 1; i <= this_parent.find('select').length; i++){
      if(i == 1){
        select_title += this_parent.find('.mvu-opt-select-'+i).val();
      }else{
        select_title += ' / ' + this_parent.find('.mvu-opt-select-'+i).val();
      }
  }
  select_variant_id = getVariant(mv_upsell_variants_obj, select_title);
  console.log(select_variant_id);
});

function getVariant(obj, value){
  for(var i = 0; i < obj.length; i++){
    if(obj[i].title === value){
      return mv_upsell_variants_obj[i].id;
    }
  }
}

$('#mvu-addToCart-btn').on('click', function(e){
  e.preventDefault();
  var quantity = $(this).closest('.mvu-content-lower').find('input.mvu-quantity-input').val();
  $.ajax({
    url: 'cart/add.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: {
      quantity: parseInt(quantity),
      id: select_variant_id
    },
    beforeSend: function() {
      
    },
    success: function(itemData) {
      location.reload();
    },
    error: function(XMLHttpRequest) {
      var response = eval('(' + XMLHttpRequest.responseText + ')');
      response = response.description;

      console.error(response);
      alert(response);
    }
  });
});